import { render } from "./Form.vue?vue&type=template&id=66667184&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=66667184&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-66667184"

export default script